<!--cardapio-online\libs\core\shell\src\lib\layout\admin\shell-admin-sidebar\shell-admin-sidebar.component.html-->
<aside
  class="admin-sidebar"
  [class.admin-sidebar--mobile-open]="isMobileOpen"
  id="tour-sidebar"
>
  <div class="admin-sidebar__brand">
    <div class="admin-sidebar__brand-badge">
      <img [src]="cfg.brandLogoUrl" alt="" width="50" height="50" />
    </div>

    <div class="admin-sidebar__brand-content">
      <h1 class="admin-sidebar__brand-title">{{ cfg.appName }}</h1>
      <p class="admin-sidebar__brand-subtitle">{{ brandSubtitle }}</p>
    </div>
  </div>

  <div class="admin-sidebar__nav-group">
    <div class="admin-sidebar__nav-header">
      <p class="admin-sidebar__nav-title">Navegação</p>

      <div
        class="admin-sidebar__nav-actions"
        *ngIf="menuEditingEnabled || isMenuEditing"
      >
        <button
          *ngIf="isMenuEditing"
          type="button"
          class="admin-sidebar__icon-button admin-sidebar__icon-button--cancel"
          (click)="cancelMenuEditing()"
          aria-label="Cancelar edição da ordem do menu"
          libTooltip
          tooltipPosition="bottom"
          tooltipMessage="Cancelar edição da ordem do menu"
        >
          <i class="bx bx-x"></i>
        </button>

        <button
          *ngIf="menuEditingEnabled"
          type="button"
          class="admin-sidebar__icon-button"
          [class.admin-sidebar__icon-button--edit]="!isMenuEditing"
          [class.admin-sidebar__icon-button--save]="isMenuEditing"
          (click)="isMenuEditing ? saveMenuEditing() : startMenuEditing()"
          [attr.aria-label]="
            isMenuEditing ? 'Salvar ordem do menu' : 'Editar ordem do menu'
          "
          libTooltip
          tooltipPosition="bottom"
          [tooltipMessage]="
            isMenuEditing ? 'Salvar ordem do menu' : 'Editar ordem do menu'
          "
        >
          <i class="bx" [ngClass]="isMenuEditing ? 'bx-check' : 'bx-brush'"></i>
        </button>
      </div>
    </div>

    <ng-container *ngIf="!isMenuEditing; else editModeList">
      <div class="admin-sidebar__nav-list">
        <a
          *ngFor="let item of navItems; trackBy: trackByRoute"
          class="admin-sidebar__nav-link"
          routerLinkActive="admin-sidebar__nav-link--active"
          [routerLink]="item.route"
          (click)="handleNavigate()"
        >
          <span class="admin-sidebar__nav-label">{{ item.label }}</span>
          <span class="admin-sidebar__nav-badge" *ngIf="item.badge !== undefined">
            {{ item.badge }}
          </span>
        </a>
      </div>
    </ng-container>

    <ng-template #editModeList>
      <div
        class="admin-sidebar__nav-list"
        cdkDropList
        [cdkDropListData]="navItems"
        cdkDropListOrientation="vertical"
        (cdkDropListDropped)="onDrop($event)"
      >
        <div
          *ngFor="let item of navItems; trackBy: trackByRoute"
          class="admin-sidebar__nav-link admin-sidebar__nav-link--editing"
          cdkDrag
          cdkDragLockAxis="y"
        >
          <div class="admin-sidebar__nav-content">
            <span class="admin-sidebar__drag-handle" cdkDragHandle>
              <i class="bx bx-grid-vertical"></i>
            </span>

            <span class="admin-sidebar__nav-label">{{ item.label }}</span>
          </div>

          <span class="admin-sidebar__nav-meta">
            <span class="admin-sidebar__nav-order">
              {{ item.order }}
            </span>

            <span
              class="admin-sidebar__nav-badge"
              *ngIf="item.badge !== undefined"
            >
              {{ item.badge }}
            </span>
          </span>
        </div>
      </div>
    </ng-template>
  </div>
</aside>
  <!--
  <div class="admin-sidebar__help" id="tour-help-card">
    <strong class="admin-sidebar__help-title">Central de ajudas</strong>

    <p class="admin-sidebar__help-text">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere, massa a dapibus feugiat.
    </p>

    <button
      type="button"
      class="admin-sidebar__help-action"
      (click)="restartTutorial()"
    >
      Ver tutorial novamente
    </button>
  </div>
  -->
